// import { MdArrowForwardIos, MdArrowBackIosNew } from "react-icons/md";

// export default function Pagination({ length, page, setPage }) {
//   const total_pages = Math.ceil(parseInt(length) / 12);
//   const pages = [...Array(total_pages).keys()];

//   return (
//     <div className="flex flex-wrap justify-center items-center gap-2">
//       <button
//         className="flex items-center gap-2"
//         onClick={() => setPage(page - 1)}
//         disabled={page === 0}>
//         <MdArrowBackIosNew />
//       </button>

//       {pages
//         .slice(
//           page - 5 < 0 ? 0 : page - 5,
//           page + 5 > pages.length ? pages.length : page + 5
//         )
//         .map((a, idx) => (
//           <div
//             key={idx}
//             onClick={() => {
//               setPage(a);
//             }}
//             className={` h-6 w-6 flex items-center justify-center cursor-pointer ${
//               page === a
//                 ? "bg-[#161b22d1] text-white hover:text-white rounded-lg"
//                 : "border border-[#161b22d1] rounded-lg "
//             }`}>
//             {a + 1}
//           </div>
//         ))}

//       <button
//         className="slide_from_right flex items-center gap-2"
//         onClick={() => setPage(page + 1)}
//         disabled={page === total_pages - 1}>
//         <MdArrowForwardIos />
//       </button>
//     </div>
//   );
// }

import { MdArrowForwardIos, MdArrowBackIosNew } from "react-icons/md";

export default function Pagination({ length, page, setPage }) {
  const total_items = parseInt(length) || 0;
  const items_per_page = 12;
  const total_pages = Math.ceil(total_items / items_per_page);
  const pages = Array.from({ length: total_pages }, (_, i) => i);

  return (
    <div className="flex flex-wrap justify-center items-center gap-2 z-10">
      <button
        className="flex items-center gap-2"
        onClick={() => setPage(page - 1)}
        disabled={page === 0}>
        <MdArrowBackIosNew />
      </button>

      {pages
        .slice(
          page - 5 < 0 ? 0 : page - 5,
          page + 5 > pages.length ? pages.length : page + 5
        )
        .map((a, idx) => (
          <div
            key={idx}
            onClick={() => {
              setPage(a);
            }}
            className={` h-6 w-6 flex items-center justify-center cursor-pointer ${
              page === a
                ? "bg-[#161b22d1] text-white hover:text-white rounded-lg"
                : "border border-[#161b22d1] rounded-lg "
            }`}>
            {a + 1}
          </div>
        ))}

      <button
        className="slide_from_right flex items-center gap-2"
        onClick={() => setPage(page + 1)}
        disabled={page === total_pages - 1}>
        <MdArrowForwardIos />
      </button>
    </div>
  );
}
